import { Button, LinkButton } from "@/components/atoms";
import { EmptyState } from "@/components/molecules";
import { ClientsTab } from "../tabs";

interface ClientsEmptyStateProps {
  hasFilters?: boolean;
  tab?: ClientsTab;
  onInvite?: () => void;
}

export const ClientsEmptyState = ({ hasFilters, tab = "active", onInvite }: ClientsEmptyStateProps) => {
  const isPending = tab === "pending";
  const isArchived = tab === "archived";

  const getDescription = () => {
    if (hasFilters) {
      return "There are no clients matching your filter criteria at the moment.";
    }
    if (isPending) {
      return "No clients are pending an invitation. Get started by inviting a client.";
    }
    if (isArchived) {
      return "No clients have been archived. Removed clients will appear here.";
    }
    return "You haven't added anything to this section. Get started by clicking the button below.";
  };

  return (
    <EmptyState title="Manage Clients" description={getDescription()}>
      {!hasFilters && !isArchived && (
        <div className="flex flex-row gap-4">
          {isPending ? (
            <Button variant="primary" startIcon="Sms" size="md" onClick={onInvite}>
              Invite Client
            </Button>
          ) : (
            <LinkButton to="../clients/add" variant="primary" startIcon="Add" size="md">
              Add Client
            </LinkButton>
          )}
        </div>
      )}
    </EmptyState>
  );
};
